// extracted by mini-css-extract-plugin
export var modalFooter = "_q7-0";